export const CANCELLATION_REASONS = [
	{ value: 'no_time', label: 'Keine Zeit, das Tool zu nutzen', offer: 'fullservice', pauseSecondary: true },
	{
		value: 'not_used',
		label: 'Wir nutzen die Software nicht / zu wenig Nutzen',
		offer: 'fullservice',
		pauseSecondary: true,
	},
	{ value: 'too_expensive', label: 'Zu teuer / Budget gestrichen', offer: 'pause', pauseSecondary: false },
	{ value: 'bad_timing', label: 'Gerade nicht der richtige Zeitpunkt', offer: 'pause', pauseSecondary: false },
	{ value: 'missing_features', label: 'Fehlende Funktionen', offer: 'call', pauseSecondary: true },
	{ value: 'technical_issues', label: 'Technische Probleme', offer: 'call', pauseSecondary: false },
	{ value: 'switching', label: 'Wechsel zu einem anderen Anbieter', offer: null, pauseSecondary: false },
	{ value: 'business_closed', label: 'Geschäft eingestellt / kein Bedarf mehr', offer: null, pauseSecondary: false },
	{ value: 'other', label: 'Sonstiges', offer: 'pause', pauseSecondary: false },
];

export const PAUSE_MONTH_OPTIONS = [1, 2, 3];

export const OFFER_TYPES = ['fullservice', 'call', 'pause', 'none'];

export const COMMENT_MAX_LENGTH = 500;

/**
 * Resolves the single retention offer for a cancellation reason. Any pause offer — primary or the
 * secondary "Oder erst einmal pausieren" link — is dropped when the subscription is not pause-eligible,
 * so the UI never shows an option the backend would reject.
 *
 * @param {string|null} reasonValue - one of CANCELLATION_REASONS[].value
 * @param {boolean} pauseEligible - whether at least one pause window can be offered (see canOfferPause)
 * @returns {{ type: ('fullservice'|'call'|'pause'|null), pauseSecondary: boolean }}
 */
export function resolveOffer(reasonValue, pauseEligible) {
	const reason = CANCELLATION_REASONS.find((entry) => entry.value === reasonValue);
	if (!reason) return { type: null, pauseSecondary: false };

	const type = reason.offer === 'pause' && !pauseEligible ? null : reason.offer;
	return { type, pauseSecondary: Boolean(pauseEligible && reason.pauseSecondary) };
}

/**
 * Picks the wizard step that follows the reason step: an offer screen, the pause step, or — when there
 * is nothing to offer — the plain confirmation.
 *
 * @param {string|null} reasonValue
 * @param {boolean} pauseEligible
 * @returns {'offer'|'pause'|'confirm'}
 */
export function nextStepAfterReason(reasonValue, pauseEligible) {
	const { type } = resolveOffer(reasonValue, pauseEligible);
	if (type === 'pause') return 'pause';
	if (type === null) return 'confirm';
	return 'offer';
}
